import {
  BillingTypeFormFacility,
  PaymentStatus,
} from "../../assets/data/Constants";
import { TkGetCodeList } from "../../utils/TkGetCode";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const searchFormList: any = [
  {
    keyword: "searchKbn",
    type: "selectFrom",
    label: "区分",
    selectPropsList: TkGetCodeList(BillingTypeFormFacility),
  },
  {
    keyword: "searchBillingContractor",
    type: "label",
    label: "請求先",
    inputProps: {
      maxLength: 85,
    },
  },
  {
    keyword: "searchReceiveStatus",
    type: "selectFrom",
    label: "入金状況",
    selectPropsList: TkGetCodeList(PaymentStatus),
  },
];

const searchFormSchema = {
  searchBillingContractor: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
};

const headList: any = [
  {
    headTitle: "請求ID",
  },
  {
    headTitle: "請求日",
  },
  {
    headTitle: "請求先",
  },
  {
    headTitle: "区分",
  },
  {
    headTitle: "請求金額",
  },
  {
    headTitle: "請求状況",
  },
  {
    headTitle: "入金状況",
  },
  {
    headTitle: "入金額",
  },
];

export { searchFormList, searchFormSchema, headList };
